import { SupportCardProps } from "@/components/screen/global-components/support/SupportCard";
import * as images from "@/components/images/Images";

const privacySupportCards: SupportCardProps[] = [
  {
    title: "Support",
    description:
      "Get immediate answers to your questions on translation best practices, our services, pricing, and more.",
    imageUrl: images.security_support1,
    href: '/support',
    linkLabel: "Contact us",
  },
  {
    title: "Privacy Policy",
    description:
      "Protecting your privacy and data is very important to us. We only use your data within the scope of legal regulations, which you can learn more about in our privacy policy.",
    imageUrl: images.security_support2,
    href: "/privacy-policy",
    linkLabel: "Learn more",
  },
  {
    title: "Terms of Service",
    description:
      "Languex terms and conditions outline the rules, responsibilities and limitations of using Languex’ website, products, and services. ",
    imageUrl: images.security_support3,
    href: "/terms-of-service",
    linkLabel: "Learn more",
  },
];

export const privacySupportData = {
  title: "Explore our trust, security, and support",
  description: null,
  cards: privacySupportCards,
};
